import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

// The prerendered HTML carries its own JSON-LD for crawlers that don't run JS;
// once Helmet takes over it would be a duplicate.
document.querySelectorAll('script[data-prerender-schema]').forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
